// API Endpoints
export const API_BASE_URL = '';

export const AUTH_ENDPOINTS = {
  LOGIN: '/api/services/auth/login',
  VERIFY: '/api/services/auth/verify',
  LOGOUT: '/api/services/auth/logout',
  FORGOT_PASSWORD: '/api/services/auth/forgot-password',
  CHANGE_PASSWORD: '/api/services/auth/change/password',
  REGISTER_USER: '/api/services/auth/register',
};

export const TIMESHEET_ENDPOINTS = {
  GET_REGISTRAZIONI: '/api/services/timesheet',
  ADD_REGISTRAZIONE: '/api/services/timesheet',
  UPDATE_REGISTRAZIONE: '/api/services/timesheet/:id',
  DELETE_REGISTRAZIONE: '/api/services/timesheet/:id',
};

export const STRUTTURE_ENDPOINTS = {
  GET_STRUTTURE: '/api/services/strutture',
};

export const SOCIETA_ENDPOINTS = {
  GET_SOCIETA: '/api/services/societa',
};

export const ADMIN_ENDPOINTS = {
  GET_STATS: '/api/services/amministrazione/statistiche',
  GET_STRUTTURE: '/api/services/amministrazione/riepilogo/ufficio',
  GET_OPERATORI: '/api/services/amministrazione/riepilogo/operatore',
  EXPORT_EXCEL_UFFICI: '/api/services/ore_strutture/export',
  EXPORT_EXCEL_OPERATORI: '/api/services/timesheet/export',
};

export const OPERATORI_ENDPOINTS = {
  ADD_OPERATORE: '/api/services/operatore',
  UPDATE_OPERATORE: '/api/services/operatore/:id',
  DELETE_OPERATORE: '/api/services/operatore/:id',
};

// Uffici disponibili
export const UFFICI_LIST = [
  'Sede Centrale',
  'Filiale Nord',
  'Filiale Sud',
  'Ufficio Remoto',
];

// Configurazione fetch
export const FETCH_OPTIONS = {
  credentials: 'include' as const,
  headers: {
    'Content-Type': 'application/json',
  },
};
